import { Dispatch, FC, SetStateAction } from 'react'
import { IStreet } from '../../../types/project.types'
import classes from '../infrastructure-tabs/styles.module.scss'
import { useTranslation } from 'react-i18next'
import { MinusIcon, PlusBigIcon } from '../../../assets/icons'
import Documentation from './documentation.component'
import ImageGrid from './image-grid.component'
import { convertFilesToImageDate } from '../../../helpers/utils'
import { useParams } from 'react-router-dom'
interface IProps {
  list: IStreet[]
  isOpen: Record<string, boolean>
  setIsOpen: Dispatch<SetStateAction<Record<string, boolean>>>
}

const baseClass = 'street-list'
const baseTranslationKey = 'projects.infrastructure-projects'

const StreetList: FC<IProps> = ({ list, isOpen, setIsOpen }) => {
  const { t, i18n: { language } } = useTranslation();
  const suffix = language === 'ru' ? 'Ru' : 'Kz';
  const { type } = useParams();

  const renderFieldRowItem = (labelKey: string, value: string | number | undefined, unit?: string) => (
    <div className={classes['field-row__item']}>
      <span className={classes['field-row__label']}>{t(labelKey)}:</span>
      <span className={classes['field-row__value']}>
        {value} {unit || ''}
      </span>
    </div>
  );

  const renderRequirementsBlock = (item: IStreet) => {
    if (!item.repairRequired) return null;

    const isNeeded = item.repairRequired.toString() === 'true';
    if (!isNeeded) return null;
    return (
      <>
        <div className={classes['field-block']}>
          <div className={classes['field-block__title']}>
            {t(`${baseTranslationKey}.renovation`)}
          </div>

          <div className={classes['field-row']}>
            <div className={classes['field-row__item']}>
              <span className={classes['field-row__label']}>{t(`${baseTranslationKey}.renovation-required`)}</span>
            </div>
          </div>
        </div>

        {isNeeded ? <Documentation data={item} /> : null}
      </>
    );
  };

  return (
    <div className={classes[baseClass]}>
      <span className={classes[`${baseClass}__title`]}>{t(`projects.infrastructure-projects.street.title`)}</span>
      {list.map(item => (
        <div key={item.id} className={classes['project-item']}>
          <div
            className={classes['project-item__header']}
            onClick={() =>
              setIsOpen(prev => ({ ...prev, [`${type}-${item.id}`]: !prev[`${type}-${item.id}`] }))
            }
          >
            <div className={classes['project-item__icon']}>
              {isOpen[`${type}-${item.id}`] ? <MinusIcon /> : <PlusBigIcon />}
            </div>
            <span className={classes['project-item__title']}>
              {item[`name${suffix}`] ?? '-'}
            </span>
          </div>

          {
            isOpen[`${type}-${item.id}`] && <div className={classes['project-item__body']}>
              <div className={classes['field-row']}>
                {['totalStreetLength'].map(field => {
                  const value = item[field as keyof IStreet] as string | number | undefined;
                  const unit =
                    field === 'constructionYear'
                      ? ''
                      : t(`km`)
                  return renderFieldRowItem(`${baseTranslationKey}.village-road.${field}`, value, unit);
                })}
                {renderFieldRowItem(
                  `${baseTranslationKey}.street.VILLAGE_ROAD.factCondition`,
                  t(`${baseTranslationKey}.${item.factCondition?.toLowerCase()}`)
                )}
              </div>

              {renderRequirementsBlock(item)}
              {item.files && <ImageGrid images={convertFilesToImageDate(item.files)} />}
            </div>
          }
        </div>
      ))}
    </div>
  )

}

export default StreetList